import type { PlanFeatures } from "@/features/auth/types/plan.type";

export const CATALOGUE_IDS = {
  CADEAUX: 1,
  CINEMA: 2,
  PARCS_LOISIRS: 3,
  BILLETTERIE: 5,
} as const;

export const CATALOGUE_PATHS = {
  CADEAUX: "/boutique/cadeaux",
  CINEMA: "/boutique/cinema",
  PARCS_LOISIRS: "/boutique/parcs-loisirs",
  FITNESS: "/boutique/fitness",
} as const;

export const CATALOGUE_CONFIG = {
  [CATALOGUE_IDS.CADEAUX]: {
    id: CATALOGUE_IDS.CADEAUX,
    name: "Bons cadeaux",
    path: CATALOGUE_PATHS.CADEAUX,
    feature: "catalog_gifts" as const,
  },
  [CATALOGUE_IDS.CINEMA]: {
    id: CATALOGUE_IDS.CINEMA,
    name: "Cinéma",
    path: CATALOGUE_PATHS.CINEMA,
    feature: "catalog_cinemas" as const,
  },
  [CATALOGUE_IDS.PARCS_LOISIRS]: {
    id: CATALOGUE_IDS.PARCS_LOISIRS,
    name: "Parcs & Loisirs",
    path: CATALOGUE_PATHS.PARCS_LOISIRS,
    feature: "catalog_parks" as const,
  },
} as const;

export type CatalogueId = (typeof CATALOGUE_IDS)[keyof typeof CATALOGUE_IDS];
export type CataloguePath =
  (typeof CATALOGUE_PATHS)[keyof typeof CATALOGUE_PATHS];

// Code-keyed catalogue config (source of truth for env-portable
// resolution). The numeric `WfCatalogue.id` differs between environments,
// so navigation, feature-gating and path resolution look catalogues up by
// their stable `code` (returned by the catalogues API). Existing verticals
// keep their id-based config above for the product-detail URL scheme; new
// verticals (Fitness) are resolved purely by code — no hardcoded id.
export type CatalogueCodeConfig = {
  code: string
  name: string
  path: string
  feature: keyof PlanFeatures
};

export const CATALOGUE_CONFIG_BY_CODE: Record<string, CatalogueCodeConfig> = {
  cadeaux: {
    code: "cadeaux",
    name: "Bons cadeaux",
    path: CATALOGUE_PATHS.CADEAUX,
    feature: "catalog_gifts",
  },
  cinemas: {
    code: "cinemas",
    name: "Cinéma",
    path: CATALOGUE_PATHS.CINEMA,
    feature: "catalog_cinemas",
  },
  parcs: {
    code: "parcs",
    name: "Parcs & Loisirs",
    path: CATALOGUE_PATHS.PARCS_LOISIRS,
    feature: "catalog_parks",
  },
  tickets: {
    code: "tickets",
    name: "Billetterie",
    path: "/boutique/billetterie",
    feature: "catalog_tickets",
  },
  fitness: {
    code: "fitness",
    name: "Fitness",
    path: CATALOGUE_PATHS.FITNESS,
    feature: "catalog_fitness",
  },
};

export const FITNESS_CATALOGUE_CODE = "fitness";

export const catalogueConfigByCode = (
  code: string | null | undefined,
): CatalogueCodeConfig | undefined =>
  (code ? CATALOGUE_CONFIG_BY_CODE[code] : undefined);
